/**
 * Router `state` carrying a one-shot success message to the page navigated
 * to, e.g. `navigate("/", { state: flashState("File uploaded successfully.") })`.
 * The root layout shows it as a toast on arrival.
 */
export type TFlashState = { flash: string };

export const flashState = (message: string): TFlashState => ({ flash: message });

export const readFlash = (state: unknown): string | null => {
    if (typeof state !== "object" || state === null || !("flash" in state)) return null;
    const { flash } = state;
    return typeof flash === "string" && flash ? flash : null;
};
